export default __webpack_public_path__ + "static/dd_glyph-53b2444e46776e1b20e1626377ab06de.svg";